import { PremiumBadge, Tick, Wrap } from "./ui"

const VORTEILE = [
  ["Vergünstigter Zugang", "Vergünstigter Zugang zum SINUS Milieu-Navigator."],
  ["Individuelle Beratung", "Online-Beratungsgespräch zu Ihren individuellen Fragen."],
  ["Exklusive Booklets", "SINUS-Booklets zu Sonderthemen (z. B. Trends, Generationen)."],
  ["Exklusive Inhalte", "Webinar-Aufzeichnungen, Handouts und weitere Exklusiv-Informationen."],
]

export function PremiumBand() {
  return (
    <div className="my-16 bg-surface py-16 md:my-24 md:py-24">
      <Wrap className="grid items-center gap-10 md:grid-cols-2 md:gap-20">
        <div>
          <h3 className="text-lg font-medium md:text-xl">Forschung mit Vorteilen</h3>
          <p className="mt-3 text-xs text-brand-muted md:text-sm">
            Zugang zu erworbenen Infopaketen erhalten Sie über unser SINUS Infoportal. Der
            Basis-Zugang wird Ihnen automatisch mit der Bestellung eines Infopakets zur Verfügung
            gestellt.
          </p>
          <p className="mt-4 text-xs text-brand-muted md:text-sm">
            Ab einem Auftragswert von 4.150 Euro innerhalb der letzten 2 Kalenderjahre bieten wir
            einen Premium-Status im SINUS Infoportal an.
          </p>
        </div>

        <div className="rounded-card bg-white p-5 shadow-card md:p-7">
          <div className="flex items-center justify-between gap-3">
            <h3 className="text-base font-medium text-brand-blue md:text-lg">Premium-Status</h3>
            <PremiumBadge />
          </div>
          <p className="mt-2 text-xs text-brand-muted md:text-sm">
            Mit dem Premium-Status stehen Ihnen folgende Vorteile zur Verfügung.
          </p>
          <ul className="mt-4 flex flex-col gap-2.5">
            {VORTEILE.map(([title, text]) => (
              <li key={title} className="flex gap-2.5">
                <Tick className="mt-0.5" />
                <span className="text-xs leading-snug md:text-sm">
                  <span className="block font-medium">{title}</span>
                  <span className="block text-brand-muted">{text}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </Wrap>
    </div>
  )
}
